import { render, staticRenderFns } from "./Siup.vue?vue&type=template&id=7bb5810a&scoped=true&"
import script from "./Siup.vue?vue&type=script&lang=js&"
export * from "./Siup.vue?vue&type=script&lang=js&"
import style0 from "./Siup.vue?vue&type=style&index=0&id=7bb5810a&scoped=true&lang=css&"
import style1 from "./Siup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb5810a",
  null
  
)

export default component.exports